import { AcroNode } from "./types";
import { renderNode } from "./renderNode";

export function renderGroupAllowMultipleTable(node: AcroNode): string {
  if (node.type !== 'group' || !node.allow_multiple) return '';
  const children = node.children ?? [];
  if (!Array.isArray(children) || children.length === 0) return '';


  let tableBody = '';
  // If children have no children, render each as a row with a single td (with label)
  if (children.every(child => !child.children || child.children.length === 0)) {
    tableBody = children.map(child => `<tr><td>${renderNode(child)}</td></tr>`).join('');
  } else {
    // Render each child as a row, each grandchild as a cell
    tableBody = children.map(rowNode => {
      const rowChildren = rowNode.children ?? [];
      return `<tr>${rowChildren.map(cellNode => `<td>${renderNode(cellNode)}</td>`).join('')}</tr>`;
    }).join('');
  }

  // Add Row control
  const nextIndex = children.length + 1;
  const addRowControls = `<div class="flex items-center">
    <button type="button" class="!my-4 !mr-4 !px-3 !py-2 btn-primary text-xs rounded border border-gray-300 hover:bg-gray-50"
      data-action="add-row" data-table-id="${node.id ?? ''}" data-next-index="${nextIndex}">
      Add row
    </button>
  </div>`;

  return `
    <div class="mb-3 border border-gray-200 overflow-hidden rounded-lg w-full">
      <table class="table-auto dynamic-table w-full text-sm !border-none !m-0" data-table-id="${node.id ?? ''}">
        <tbody>
          ${tableBody}
        </tbody>
      </table>
      ${addRowControls}
    </div>
  `;
}
